import TScrollSpy from './scroll-spy.vue'
export ScrollSpy from '../../directives/scroll-spy'

TScrollSpy.install = Vue => {
  Vue.component(TScrollSpy.name, TScrollSpy)
}

export {
  TScrollSpy
}



// WEBPACK FOOTER //
// ./src/module/scroll-spy/index.js